import React, { FC } from "react";
// @ts-ignore
import { PageFooter } from "@ruter-ds/rds-components";

const Footer: FC = () => {
  return <PageFooter />;
};

export default Footer;
